const metafield = {
  namespace: "__helium_intelligence__",
  tagKey: "tags",
  similarKey: "similar",
  complementaryKey: "complementary",
};

export const productDetailsQuery = `#graphql
query product($id: ID!) {
product(id: $id) {
title
description
handle
featuredImage {
  src
width
height
altText
}
}
}
`;

export const GetProductByIdQuery = `
  query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      # Basic Info
      id # GraphQL GID (e.g., gid://shopify/Product/123)
      handle
      title
      descriptionHtml # Use this for HTML description
      description # Plain text description
      vendor
      createdAt
      updatedAt

      # Featured Image
      featuredImage {
        url # Use 'url' directly (preferred over src)
        width
        height
        altText
      }

      # Media (includes images with more details)
      # Using 'media' instead of 'images' to get dimensions and type easily
      media(first: 10) {
        edges {
          node {
            # Common fields for all media
            alt
            mediaContentType # e.g., IMAGE, VIDEO
            # Fields specific to ImageMedia
            ... on MediaImage {
              id # GID for the media item
                image {
                  url
                  width
                  height
               }
              image { # Main image data
                url
                width
                height
              }
            }
             # Add other media types like Video if needed
            # ... on Video { ... }
          }
        }
      }

      # Variants
      variants(first: 100) {
        edges {
          node {
            id # GraphQL GID for Variant (e.g., gid://shopify/ProductVariant/456)
            title # Usually the combination of option values (e.g., "M / Red")
            selectedOptions {
              name
              value
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice { # Add compareAtPrice if needed
              amount
              currencyCode
            }
            availableForSale
            sku
            image { # Associated image for this variant
              url
              altText
              width
              height
            }
          }
        }
      }

      # Options
      options {
        name
        optionValues{
          name
          firstSelectableVariant{
           image{
          url
          }
            title
            id
          }
        }
      }

      # Price Ranges
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange { # Added compareAtPriceRange
         minVariantPrice {
           amount
           currencyCode
         }
         maxVariantPrice {
           amount
           currencyCode
         }
       }
    }
  }
`;

export const ProductDetailsFragment = `
  fragment ProductDetailsFragment on Product {
          # Basic Info
      id # GraphQL GID (e.g., gid://shopify/Product/123)
      handle
      title
      descriptionHtml # Use this for HTML description
      description # Plain text description
      vendor
      createdAt
      updatedAt

      # Featured Image
      featuredImage {
        url # Use 'url' directly (preferred over src)
        width
        height
        altText
      }

      # Media (includes images with more details)
      # Using 'media' instead of 'images' to get dimensions and type easily
      media(first: 10) {
        edges {
          node {
            # Common fields for all media
            alt
            mediaContentType # e.g., IMAGE, VIDEO
            # Fields specific to ImageMedia
            ... on MediaImage {
              id # GID for the media item
                image {
                  url
                  width
                  height
               }
              image { # Main image data
                url
                width
                height
              }
            }
             # Add other media types like Video if needed
            # ... on Video { ... }
          }
        }
      }

      # Variants
      variants(first: 100) {
        edges {
          node {
            id # GraphQL GID for Variant (e.g., gid://shopify/ProductVariant/456)
            title # Usually the combination of option values (e.g., "M / Red")
            selectedOptions {
              name
              value
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice { # Add compareAtPrice if needed
              amount
              currencyCode
            }
            availableForSale
            sku
            image { # Associated image for this variant
              url
              altText
              width
              height
            }
          }
        }
      }

      # Options
      options {
        name
        optionValues{
          name
          firstSelectableVariant{
           image{
          url
          }
            title
            id
          }
        }
      }

      # Price Ranges
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange { # Added compareAtPriceRange
         minVariantPrice {
           amount
           currencyCode
         }
         maxVariantPrice {
           amount
           currencyCode
         }
       }
  }
`;
